<!-- icon组件，1-8个 -->
<template>
  <div class="tabMenus" :style="{'margin-bottom': (data.marginBottom) / 16 + 'rem', background: data.background,}">
    <div class="list">
      <div v-for="(item,index) in data.icons" :key="index" class="item" @click="handleJump(item)">
        <div class="img-wrapper">
          <img :src="item.iconUrl">
          <span v-if="item.tipText">{{ item.tipText }}</span>
        </div>
        <p>{{ item.title }}</p>
      </div>
    </div>
  </div>

</template>

<script>
import clientUtil from '../common/clientUtil';
export default {
  name: "IconSetting",
  props: {
    data: {
      type: Object,
      default: () => { return {} }
    }
  },
  methods: {
    handleJump(item) {
      clientUtil.openNewWebPage({
        pageUrl: item.link
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .tabMenus {
    width: 100%;
    box-sizing: border-box;
    padding: 20px 11px 0px;
    border-radius: 8px;
    margin-top: 10px;
    position: relative;
  }
  .list{
    width:100%;
    display: flex;
    flex-wrap: wrap;
  }
  .item{
    position: relative;
    text-align: center;
    margin-bottom: 24px;
    width:25%;
    .img-wrapper{
        position: relative;
        height:40px;
    }
    img{
      width: 40px;
      height: auto;
      display: block;
      border:0;
      margin:0 auto;
    }
    p{
      font-size: 13px;
      color:#2e2e33;
      margin:10px 0 0;
    }
    span{
        position: absolute;
        top:0px;
        left:50%;
        background: #FF3838;
        font-size: 12px;
        color: #fff;
        text-align: center;
        width: 40px;
        height: 16px;
        line-height: 16px;
        border-radius: 13px;
        z-index:1;
        &:after{
          content:'';
          border-left: 8px solid #FF3838;
          border-bottom: 8px solid transparent;
          border-right: 8px solid transparent;
          border-top: 8px solid transparent;
          position: absolute;
          bottom: -5px;
          left: 5px;
          z-index: -1;
        }
    }
  }
</style>
